// extracted by mini-css-extract-plugin
export default {"mCard":"bE-z","image":"cE-z","imageNoBackground":"dE-z","imageHasCategory":"eE-z","fullWidth":"fE-z"};